import React from 'react'

import { ROUTE_NAME, API_URL } from '../constants'

import ItemDelete from '../../../components/Delete'

const IncidentTypeBufferDelete = () => (
  <ItemDelete
    routeName={ROUTE_NAME}
    apiUrl={API_URL}
    label={(item) =>
      `Incident Type Buffer (#${item.id}): ${item.incidentType.name} (${item.incidentType.code}) - ${item.aiLayer.name} - ${item.distance} ${item.unit}`
    }
  />
)

export default IncidentTypeBufferDelete
